import { render, staticRenderFns } from "./warehouseSummary.vue?vue&type=template&id=3d50e9b5&scoped=true&"
import script from "./warehouseSummary.vue?vue&type=script&lang=js&"
export * from "./warehouseSummary.vue?vue&type=script&lang=js&"
import style0 from "./warehouseSummary.vue?vue&type=style&index=0&id=3d50e9b5&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d50e9b5",
  null
  
)

export default component.exports